import gql from 'graphql-tag';

export const ForYourBoardFragment = gql`
fragment ForYourBoardFragment on BoardModel {
  id
  name
  publicName
  mainBoardAsset {
    id
    asset {
      id
      assetTypeId
      url
    }
  }
  boardProductCount
  designer {
    id
    firstName
    photo
    vanityId
  }
  subStyles {
    id
    name
  }
  roomType {
    id
    type
  }
}
`;

export const ForYouBoardsQuery = gql`
${ForYourBoardFragment}

query ForYouBoards(
  $userId: ID!,
  $pageNumber: Int,
  $pageSize: Int,
) {
  forYouBoards(
    userId: $userId,
    pageNumber: $pageNumber,
    pageSize: $pageSize,
  ) {
    pageSize
    pageNumber
    itemCount
    items {
      ...ForYourBoardFragment
    }
  }
}
`;

export const ForYouBoardsDefaultQuery = gql`
${ForYourBoardFragment}

query ExploreBoardFeed(
  $pageNumber: Int!,
  $pageSize: Int!,
) {
  forYouBoards: exploreFeedBoards(
    pageNumber: $pageNumber,
    pageSize: $pageSize,
  ) {
      itemCount
      pageNumber
      pageSize
      items {
        ...ForYourBoardFragment
      }
    }
  }
`;

export default ForYouBoardsQuery;
